import type { CartItemPricing } from 'domains/cart_products';

export type CartOrderOptionCreateParams = {
  option_api_id: number;
  quantity: number;
};

export type CartOrderOption = {
  id: number;
  name: string;
  quantity: number;
  option_api_id: number;
  created_at: string;
  updated_at: string;
  pricing?: CartItemPricing;
};
